import styled from 'styled-components'

export interface TabsItemProps {
  title: string
  id: string | number
}

export function Tabs(props: {
  items: TabsItemProps[]
  value: TabsItemProps['id']
  onChange: (id: TabsItemProps['id']) => void
}) {
  return (
    <TabWrapper nums={props.items.length}>
      {props.items.map((item) => (
        <TabItem selected={props.value === item.id} onClick={() => props.onChange(item.id)} key={item.id}>
          {item.title}
        </TabItem>
      ))}
    </TabWrapper>
  )
}

const TabWrapper = styled.div<{ nums: number }>`
  width: 1150px;
  height: 50px;
  border-bottom: 1px solid #1e46a1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  cursor: not-allowed;
  padding-left: 20px;
`

const TabItem = styled.button<{ selected?: boolean; disable?: boolean }>`
  width: 128px;
  height: 50px;
  border-radius: 10px 10px 0 0;
  margin-right: 14px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  ${({ selected }) =>
    selected
      ? `
    background: #00F4E4;
    color: #022981;
  `
      : `
      background: #11388C;
      color: #74A0FF;
  `};
  transition: all linear 0.1s;
`
